<template>
    <main id="settings_main" class="page__profile" role="main" v-cloak>
        <div class="o-wrapper">
            <div class="o-grid">
                <aside class="profile__sidebar o-grid__item u-width-3/12 u-width-full@m">
                    <div class="profile__sidebar__main">
                        <ul>
                            <router-link tag="li" to="/settings" exact-active-class="active"><a>Edit Profile</a></router-link>
                            <!-- <router-link tag="li" to="/settings/invite-friends"><a>Invite Friends</a></router-link> -->
                            <!-- <router-link tag="li" to="/settings/accreditations"><a>Accreditations</a></router-link> -->
                            <!-- <router-link tag="li" to="/settings/change-password"><a>Change Password</a></router-link> -->
                            <router-link tag="li" to="/settings/email" exact-active-class="active"><a>Email Preferences</a></router-link>
                            <router-link tag="li" to="/settings/interests" exact-active-class="active"><a>My Interests</a></router-link>
                        </ul>
                    </div>

                    <div class="profile__sidebar__sub">
                        <ul>
                            <!--<li><a href="/about">About Dyadey</a></li>-->
                            <li><a href="/contact">Contact Us</a></li>
                            <li><a href="/faqs">FAQ's</a></li>
                            <li><a href="/terms">Terms &amp; Conditions</a></li>
                            <li><a href="/privacy">Privacy Policy</a></li>
                            <li><a href="/cookies">Cookie Policy</a></li>
                        </ul>
                    </div>
                </aside>
                <div class="u-width-1/12"></div>
                <router-view></router-view>
            </div>
        </div>
    </main>
</template>

<script>
export default {

}
</script>
